var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
const LinkBehavior = React.forwardRef(function LinkBehavior(props, ref) {
    const { href } = props, other = __rest(props, ["href"]);
    return _jsx(RouterLink, Object.assign({ ref: ref, to: href }, other));
});
export default LinkBehavior;
